import styled from 'styled-components';
import ChartCard from '../ChartCard';

export const CustomChartCard = styled(ChartCard)`
  /* max-width: 478px; */
  height: 696px;
`;

export const FullHeightContainer = styled.div`
  height: 100%;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 40px);
`;
